import React from "react";
import { Row, Col, Card, Skeleton } from "antd";
import { UIBreadcrumb } from "../common/UIBreadcrumb";

const DashboardSkeleton = () => {
  return (
    <div style={{ padding: "22px 24px" }}>
      <div style={{display:"flex", flexWrap:"wrap", justifyContent:"space-between"}}>
        <Skeleton.Button active  style={{ height: 40, width:400, marginBottom:16 }} />
        <div style={{display:"flex",  flexWrap:"wrap", gap:10}}>
            <Skeleton.Button active  style={{ height: 40, width:50, marginBottom:16 }} />
            <Skeleton.Button active  style={{ height: 40, width:150, marginBottom:16 }} />
        </div>
      </div>
      <Row gutter={16} style={{ marginBottom: 20 }}>
        {[1, 2, 3, 4].map((item) => (
          <Col xs={24} sm={12} md={6} key={item}>
            {/* <Card> */}
              <Skeleton.Button active block style={{ height: 80 }} />
            {/* </Card> */}
          </Col>
        ))}
      </Row>

      <Row gutter={16}>
        {/* Active Jobs */}
        <Col xs={24} md={16}>
          {/* <Card> */}
            {/* {[1, 2, 3].map((item) => ( */}
            {/* //   <Card
            //     key={item}
            //     style={{ marginBottom: 16 }}
            //     bodyStyle={{ padding: "16px" }}
            //   > */}
                <Skeleton.Button active block style={{ height: 600, marginBottom: 16 }} />
            {/* //   </Card> */}
            {/* ))} */}
          {/* </Card> */}
        </Col>

        {/* Average Days Process */}
        <Col xs={24} md={8}>
          {/* <Card> */}
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {/* {[1, 2, 3, 4].map((i) => ( */}
                <Skeleton.Button
                //   key={i}
                  active
                  style={{ width: "100%", height: 600 }}
                />
              {/* ))} */}
            </div>
          {/* </Card> */}
        </Col>
      </Row>
    </div>
  );
};

export default DashboardSkeleton;
